/* eslint-disable */
// @ts-nocheck

// hasSideEffects in the file name is important, see package.json and https://webpack.js.org/guides/tree-shaking

// PatternFill plugin broken with dataGrouping
// https://github.com/highcharts/highcharts/issues/16172
// https://github.com/Metroscope-dev/metroscope/commit/f7d99ebc7f28ad41e2e9ca818e9ef01fe4fd88eb

// replaces
// import "highcharts/es-modules/Extensions/PatternFill";

import A from "highcharts/es-modules/Core/Animation/AnimationUtilities.js";
const animObject = A.animObject;
import Chart from "highcharts/es-modules/Core/Chart/Chart.js";
import H from "highcharts/es-modules/Core/Globals.js";
import D from "highcharts/es-modules/Core/DefaultOptions.js";
const getOptions = D.getOptions;
import Point from "highcharts/es-modules/Core/Series/Point.js";
import Series from "highcharts/es-modules/Core/Series/Series.js";
import SVGRenderer from "highcharts/es-modules/Core/Renderer/SVG/SVGRenderer.js";
import U from "highcharts/es-modules/Core/Utilities.js";
const addEvent = U.addEvent,
  erase = U.erase,
  merge = U.merge,
  pick = U.pick,
  removeEvent = U.removeEvent,
  wrap = U.wrap;
// Add the predefined patterns
const patterns = (H.patterns = (function () {
  const patterns = [],
    colors = getOptions().colors;
  // Start with subtle patterns
  [
    "M 0 0 L 5 5 M 4.5 -0.5 L 5.5 0.5 M -0.5 4.5 L 0.5 5.5",
    "M 0 5 L 5 0 M -0.5 0.5 L 0.5 -0.5 M 4.5 5.5 L 5.5 4.5",
    "M 2 0 L 2 5 M 4 0 L 4 5",
    "M 0 2 L 5 2 M 0 4 L 5 4",
    "M 0 1.5 L 2.5 1.5 L 2.5 0 M 2.5 5 L 2.5 3.5 L 5 3.5",
  ].forEach((pattern, i) => {
    patterns.push({
      path: pattern,
      color: colors[i],
      width: 5,
      height: 5,
      patternTransform: "scale(1.4 1.4)",
    });
  });
  // Then add the more drastic ones
  [
    "M 0 0 L 5 10 L 10 0",
    "M 3 3 L 8 3 L 8 8 L 3 8 Z",
    "M 5 5 m -4 0 a 4 4 0 1 1 8 0 a 4 4 0 1 1 -8 0",
    "M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11",
    "M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9",
  ].forEach((pattern, i) => {
    patterns.push({
      path: pattern,
      color: colors[i + 5],
      width: 10,
      height: 10,
    });
  });
  return patterns;
})());

function hashFromObject(obj, preSeed) {
  const str = JSON.stringify(obj),
    strLen = str.length || 0;
  let hash = 0,
    i = 0,
    char,
    seedStep;
  if (preSeed) {
    seedStep = Math.max(Math.floor(strLen / 500), 1);
    for (let a = 0; a < strLen; a += seedStep) {
      hash += str.charCodeAt(a);
    }
    hash = hash & hash;
  }
  for (; i < strLen; ++i) {
    char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return hash.toString(16).replace("-", "1");
}

Point.prototype.calculatePatternDimensions = function (pattern) {
  if (pattern.width && pattern.height) {
    return;
  }
  const bBox =
      (this.graphic &&
        ((this.graphic.getBBox && this.graphic.getBBox(true)) ||
          (this.graphic.element && this.graphic.element.getBBox()))) ||
      {},
    shapeArgs = this.shapeArgs;
  // Prefer using shapeArgs, as it is animation agnostic
  if (shapeArgs) {
    bBox.width = shapeArgs.width || bBox.width;
    bBox.height = shapeArgs.height || bBox.height;
    bBox.x = shapeArgs.x || bBox.x;
    bBox.y = shapeArgs.y || bBox.y;
  }
  // For images we stretch to bounding box
  if (pattern.image) {
    // If we do not have a bounding box at this point, simply add a defer
    // key and pick this up in the fillSetter handler, where the bounding
    // box should exist.
    if (!bBox.width || !bBox.height) {
      pattern._width = "defer";
      pattern._height = "defer";
      return;
    }
    // Handle aspect ratio filling
    if (pattern.aspectRatio) {
      bBox.aspectRatio = bBox.width / bBox.height;
      if (pattern.aspectRatio > bBox.aspectRatio) {
        // Height of bBox will determine width
        bBox.aspectWidth = bBox.height * pattern.aspectRatio;
      } else {
        // Width of bBox will determine height
        bBox.aspectHeight = bBox.width / pattern.aspectRatio;
      }
    }
    // We set the width/height on internal properties to differentiate
    // between the options set by a user and by this function.
    pattern._width = pattern.width || Math.ceil(bBox.aspectWidth || bBox.width);
    pattern._height = pattern.height || Math.ceil(bBox.aspectHeight || bBox.height);
  }
  // Set x/y accordingly, centering if using aspect ratio, otherwise adjusting
  // so bounding box corner is 0,0 of pattern.
  if (!pattern.width) {
    pattern._x = pattern.x || 0;
    pattern._x +=
      bBox.x - Math.round(bBox.aspectWidth ? Math.abs(bBox.aspectWidth - bBox.width) / 2 : 0);
  }
  if (!pattern.height) {
    pattern._y = pattern.y || 0;
    pattern._y +=
      bBox.y - Math.round(bBox.aspectHeight ? Math.abs(bBox.aspectHeight - bBox.height) / 2 : 0);
  }
};

SVGRenderer.prototype.addPattern = function (options, animation) {
  let pattern,
    animate = pick(animation, true),
    animationOptions = animObject(animate),
    path,
    defaultSize = 32,
    width = options.width || options._width || defaultSize,
    height = options.height || options._height || defaultSize,
    color = options.color || "#343434",
    id = options.id,
    ren = this,
    rect = function (fill) {
      ren.rect(0, 0, width, height).attr({ fill }).add(pattern);
    },
    attribs;
  if (!id) {
    this.idCounter = this.idCounter || 0;
    id = "highcharts-pattern-" + this.idCounter + "-" + (this.chartIndex || 0);
    ++this.idCounter;
  }
  if (this.forExport) {
    id += "-export";
  }
  // Do nothing if ID already exists
  this.defIds = this.defIds || [];
  if (this.defIds.indexOf(id) > -1) {
    return;
  }
  // Store ID in list to avoid duplicates
  this.defIds.push(id);
  // Calculate pattern element attributes
  const attrs = {
    id,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: options.patternContentUnits || "userSpaceOnUse",
    width,
    height,
    x: options._x || options.x || 0,
    y: options._y || options.y || 0,
  };
  if (options.patternTransform) {
    attrs.patternTransform = options.patternTransform;
  }
  pattern = this.createElement("pattern").attr(attrs).add(this.defs);
  // Set id on the SVGRenderer object
  pattern.id = id;
  // Use an SVG path for the pattern
  if (options.path) {
    path = U.isObject(options.path) ? options.path : { d: options.path };
    // The background
    if (options.backgroundColor) {
      rect(options.backgroundColor);
    }
    // The pattern
    attribs = {
      d: path.d,
    };
    if (!this.styledMode) {
      attribs.stroke = path.stroke || color;
      attribs["stroke-width"] = pick(path.strokeWidth, 2);
      attribs.fill = path.fill || "none";
    }
    if (path.transform) {
      attribs.transform = path.transform;
    }
    this.createElement("path").attr(attribs).add(pattern);
    pattern.color = color;
    // Image pattern
  } else if (options.image) {
    if (animate) {
      this.image(options.image, 0, 0, width, height, function () {
        // Onload
        this.animate(
          {
            opacity: pick(options.opacity, 1),
          },
          animationOptions,
        );
        removeEvent(this.element, "load");
      })
        .attr({ opacity: 0 })
        .add(pattern);
    } else {
      this.image(options.image, 0, 0, width, height).add(pattern);
    }
  }
  // For non-animated patterns, set opacity now
  if (!(options.image && animate) && typeof options.opacity !== "undefined") {
    [].forEach.call(pattern.element.childNodes, child => {
      child.setAttribute("opacity", options.opacity);
    });
  }
  // Store for future reference
  this.patternElements = this.patternElements || {};
  this.patternElements[id] = pattern;
  return pattern;
};
// Make sure we have a series color
wrap(Series.prototype, "getColor", function (proceed) {
  const oldColor = this.options.color;
  // Temporarely remove color options to get defaults
  if (oldColor && oldColor.pattern && !oldColor.pattern.color) {
    delete this.options.color;
    // Get default
    proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    // Replace with old, but add default color
    oldColor.pattern.color = this.color;
    this.color = this.options.color = oldColor;
  } else {
    // We have a color, no need to do anything special
    proceed.apply(this, Array.prototype.slice.call(arguments, 1));
  }
});
// Calculate pattern dimensions on points that have their own pattern.
addEvent(Series, "render", function () {
  const isResizing = this.chart.isResizing;
  if (this.isDirtyData || isResizing || !this.chart.hasRendered) {
    (this.points || []).forEach(point => {
      const colorOptions = point.options && point.options.color;
      if (colorOptions && colorOptions.pattern) {
        // For most points we want to recalculate the dimensions on
        // render, where we have the shape args and bbox. But if we
        // are resizing and don't have the shape args, defer it, since
        // the bounding box is still not resized.
        if (isResizing && !(point.shapeArgs && point.shapeArgs.width && point.shapeArgs.height)) {
          colorOptions.pattern._width = "defer";
          colorOptions.pattern._height = "defer";
        } else {
          point.calculatePatternDimensions(colorOptions.pattern);
        }
      }
    });
  }
});
// Merge series color options to points
addEvent(Point, "afterInit", function () {
  const point = this,
    colorOptions = point.options.color;
  // Only do this if we have defined a specific color on this point. Otherwise
  // we will end up trying to re-add the series color for each point.
  if (colorOptions && colorOptions.pattern) {
    // Move path definition to object, allows for merge with series path
    // definition
    if (typeof colorOptions.pattern.path === "string") {
      colorOptions.pattern.path = {
        d: colorOptions.pattern.path,
      };
    }
    // Merge with series options
    point.color = point.options.color = merge(point.series.options.color, colorOptions);
  }
});
// Add functionality to SVG renderer to handle patterns as complex colors
addEvent(SVGRenderer, "complexColor", function (args) {
  const color = args.args[0],
    prop = args.args[1],
    element = args.args[2],
    chartIndex = this.chartIndex || 0;
  let pattern = color.pattern,
    value = "#343434";
  // Handle patternIndex
  if (typeof color.patternIndex !== "undefined" && patterns) {
    pattern = patterns[color.patternIndex];
  }
  // Skip and call default if there is no pattern
  if (!pattern) {
    return true;
  }
  // We have a pattern.
  if (pattern.image || typeof pattern.path === "string" || (pattern.path && pattern.path.d)) {
    // Real pattern. Add it and set the color value to be a reference.
    // Force Hash-based IDs for legend items, as they are drawn before
    // point render, meaning they are drawn before autocalculated image
    // width/heights. We don't want them to highjack the width/height for
    // this ID if it is defined by users.
    let forceHashId = element.parentNode && element.parentNode.getAttribute("class");
    forceHashId = forceHashId && forceHashId.indexOf("highcharts-legend") > -1;
    // If we don't have a width/height yet, handle it. Try faking a point
    // and running the algorithm again.
    if (pattern._width === "defer" || pattern._height === "defer") {
      Point.prototype.calculatePatternDimensions.call({ graphic: { element } }, pattern);
    }
    // If we don't have an explicit ID, compute a hash from the
    // definition and use that as the ID. This ensures that points with
    // the same pattern definition reuse existing pattern elements by
    // default. We combine two hashes, the second with an additional
    // preSeed algorithm, to minimize collision probability.
    if (forceHashId || !pattern.id) {
      // Make a copy so we don't accidentally edit options when setting ID
      pattern = merge({}, pattern);
      pattern.id =
        "highcharts-pattern-" +
        chartIndex +
        "-" +
        hashFromObject(pattern) +
        hashFromObject(pattern, true);
    }
    // Add it. This function does nothing if an element with this ID
    // already exists.
    this.addPattern(
      pattern,
      !this.forExport && pick(pattern.animation, this.globalAnimation, { duration: 100 }),
    );
    value = "url(" + this.url + "#" + (pattern.id + (this.forExport ? "-export" : "")) + ")";
  } else {
    // Not a full pattern definition, just add color
    value = pattern.color || value;
  }
  // Set the fill/stroke prop on the element
  element.setAttribute(prop, value);
  // Allow the color to be concatenated into tooltips formatters etc.
  color.toString = function () {
    return value;
  };
  // Skip default handler
  return false;
});
// When animation is used, we have to recalculate pattern dimensions after
// resize, as the bounding boxes are not available until then.
addEvent(Chart, "endResize", function () {
  if (
    ((this.renderer && this.renderer.defIds) || []).filter(
      id => id && id.indexOf && id.indexOf("highcharts-pattern-") === 0,
    ).length
  ) {
    // We have non-default patterns to fix. Find them by looping through
    // all points.
    this.series.forEach(series => {
      // HACK HERE
      // SEE
      // https://github.com/highcharts/highcharts/issues/16172
      (series.points || []).forEach(point => {
        const colorOptions = point.options && point.options.color;
        if (colorOptions && colorOptions.pattern) {
          colorOptions.pattern._width = "defer";
          colorOptions.pattern._height = "defer";
        }
      });
    });
    // Redraw without animation
    this.redraw(false);
  }
});
// Add a garbage collector to delete old patterns with autogenerated hashes that
// are no longer being referenced.
addEvent(Chart, "redraw", function () {
  const usedIds = {},
    renderer = this.renderer,
    // Get the autocomputed patterns - these are the ones we might delete
    patterns = (renderer.defIds || []).filter(
      pattern => pattern.indexOf && pattern.indexOf("highcharts-pattern-") === 0,
    );
  if (patterns.length) {
    // Look through the DOM for usage of the patterns. This can be points,
    // series, tooltips etc.
    [].forEach.call(
      this.renderTo.querySelectorAll('[color^="url("], [fill^="url("], [stroke^="url("]'),
      node => {
        const id =
          node.getAttribute("fill") || node.getAttribute("color") || node.getAttribute("stroke");
        if (id) {
          const sanitizedId = id.replace(renderer.url, "").replace("url(#", "").replace(")", "");
          usedIds[sanitizedId] = true;
        }
      },
    );
    // Loop through the patterns that exist and see if they are used
    patterns.forEach(id => {
      if (!usedIds[id]) {
        // Remove id from used id list
        erase(renderer.defIds, id);
        // Remove pattern element
        if (renderer.patternElements[id]) {
          renderer.patternElements[id].destroy();
          delete renderer.patternElements[id];
        }
      }
    });
  }
});
